<template>
  <v-container class="container-pedido fill-height align-start pt-3" fluid style="background-color: #f4f7f6;">

    <v-row class="header-fixo elevation-2" >
      <v-btn
      class="buton-add"
        color="primary"
        @click="$_adicionarColeta"
      >
        <v-icon left>mdi-plus</v-icon>
        Adicionar
      </v-btn>
    </v-row>

    <v-row class="lista-com-padding">

      <v-col
        v-for="ordem in data"
        :key="ordem.id"
        cols="12"
        class="mb-3">
        <v-card class="mx-4 card">
          <div 
            class="card__consumidor" 
            :class="{ 'card__consumidor--encerrada': ordem.orsdatafechamento }"
            style="cursor: pointer;"
            @click="ordem.showItems = !ordem.showItems"
            v-ripple
          >
            <div class="d-flex justify-space-between align-center">
              
              <div class="d-flex flex-column flex-grow-1 mr-3">
                <b>
                  {{ ordem.orsidcliente }} - 
                  <span v-if="ordem.orscliente">{{ ordem.orscliente }}</span>
                  <span v-else>CONSUMIDOR DIVERSOS</span>
                </b>
                
                <div class="d-flex justify-space-between align-end mt-1 w-100" style="font-size: 0.85rem; opacity: 0.95;">
  
                  <div class="d-flex flex-column">
                    <span v-if="ordem.orsdatacadastro" class="d-flex align-center mb-1">
                      Data O.S.: {{ $_FormataDataGeral(ordem.orsdatacadastro, true) }}
                    </span>
                    <span v-if="ordem.orsdatafechamento" class="d-flex align-center mb-1">
                      Data Transmissão: {{ $_FormataDataGeral(ordem.orsdatafechamento, true) }}
                    </span>

                  </div>

                  <span v-if="ordem.orsvalortotal !== null && ordem.orsvalortotal !== undefined" class="d-flex align-center ml-3">
                    <v-icon size="14" color="white" class="mr-1">mdi-cash</v-icon>
                    <b style="font-size: 0.95rem;">{{ formatarValor(ordem.orsvalortotal) }}</b>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <v-expand-transition>
            <div v-if="ordem.showItems">
              
              <div class="card__detalhe py-3">
                <div class="card__detalhe__icone-wrapper">
                  <v-icon class="card__detalhe__icone" size="60">
                    mdi-account-details
                  </v-icon>
                </div>
                
                <span class="card__detalhe-conteudo">
                  <template v-if="ordem.id || ordem.orsidnuvem">
                    <div class="d-flex justify-space-between my-1">
                      <span class="font-weight-medium">
                        Nº Ordem Serviço:
                      </span>
                      <b class="">{{ ordem.orsidnuvem || ordem.id }}</b>
                    </div>
                    <v-divider></v-divider>
                  </template>

                  <template v-if="ordem.orsquantidade">
                    <div class="d-flex justify-space-between my-1">
                      <span class="font-weight-medium">Quantidade: </span>
                      <b class="">{{ ordem.orsquantidade }}</b>
                    </div>
                    <v-divider></v-divider>
                  </template>

                  <template v-if="ordem.orsnroexterno">
                    <div class="d-flex justify-space-between my-1">
                      <span class="font-weight-medium">Nro Externo: </span>
                      <b class="">{{ ordem.orsnroexterno }}</b>
                    </div>
                    <v-divider></v-divider>
                  </template>

                  <template v-if="ordem.orsdefeito">
                    <div class="d-flex justify-space-between my-1">
                      <span class="font-weight-medium">Defeito: </span>
                      <b class="">{{ ordem.orsdefeito }}</b>
                    </div>
                    <v-divider></v-divider>
                  </template>
                  
                  <template v-if="ordem.orsobservacaoextra">
                    <div class="d-flex justify-space-between my-1">
                      <span class="font-weight-medium">Observação: </span>
                      <b class="">{{ ordem.orsobservacaoextra }}</b>
                    </div>
                    <v-divider></v-divider>
                  </template>
                  
                </span>
              </div>

              <div class="lighten-4 px-4 pb-3 pt-1" style="background-color: #f9f9f9;">
                <v-divider class="mb-2"></v-divider>
                <div class="text-subtitle-2 mb-2">Itens da Coleta:</div>
                
                <simplebar 
                  v-if="ordem.itens && ordem.itens.length > 0" 
                  class="table-scroll-container" 
                  data-simplebar-auto-hide="false"
                >
                  <div 
                    v-for="(item, index) in ordem.itens" 
                    :key="index"
                    class="mb-2 pb-2"
                    style="border-bottom: 1px dashed #e9e9e9;"
                  >
                    <div class="text-body-2 font-weight-medium mb-1 text-truncate">
                      {{ item.idcortamanhofinal }} - {{ item.descricao }}
                    </div>

                    <div class="d-flex justify-space-between align-center">
                      <span class="caption grey--text text--darken-2">
                        {{ item.quantidade }} x {{ formatarValor(item.valorliquido) }}
                      </span>
                      <div class="d-flex align-center">
                        <span v-if="item.imageCount > 0" class="d-flex align-center blue-grey--text text--darken-1 caption mr-3">
                          <v-icon small color="blue-grey" class="mr-1 midia">mdi-camera-outline</v-icon>
                          {{ item.imageCount }}
                        </span>
                        <span class="font-weight-bold body-2 green--text text--darken-3">
                          {{ formatarValor(item.quantidade * item.valorliquido) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </simplebar>

                <div v-if="!ordem.itens || ordem.itens.length === 0" class="text-center caption pa-2">
                  Nenhum item lançado nesta coleta.
                </div>

                <div class="d-flex align-center mt-3 pt-3" style="border-top: 1px solid #e0e0e0;">
                  
                  <v-btn
                    v-if="!ordem.orsdatafechamento"
                    color="error"
                    icon
                    @click.stop="$_deletarColeta(ordem)"
                    title="Deletar coleta"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>

                  <v-spacer></v-spacer>
                  
                  <v-btn 
                    :color="ordem.orsdatafechamento ? 'success' : 'primary'" 
                    outlined
                    :class="{'mr-3': !ordem.orsdatafechamento}"
                    @click.stop="$_abrirOuVisualizarColeta(ordem)" 
                  >
                    <v-icon left size="20">{{ ordem.orsdatafechamento ? 'mdi-eye' : 'mdi-pencil' }}</v-icon>
                    {{ ordem.orsdatafechamento ? 'Visualizar' : 'Editar' }}
                  </v-btn>

                  <v-btn
                    v-if="!ordem.orsdatafechamento"
                    color="primary"
                    elevation="2"
                    @click.stop="$_encerrarColeta(ordem)"
                  >
                    <v-icon left size="20">mdi-check-circle</v-icon>
                    Encerrar
                  </v-btn>

                </div>
              </div>

            </div>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>  


      <BottomSheetHandler
        :aberto.sync="encerrarSheet"
        tipo="encerrar"
        :dados="ordemSelecionada"
        @encerrar="$_confirmEncerrar"
      />

      <BottomSheetHandler
        :aberto.sync="deletarSheet"
        tipo="deletarcoleta"
        :dados="coletaSelecionadaDeletar"
        @deletarcoleta="$_confirmDeletarColeta"
      />

      <BottomSheetHandler
        :aberto.sync="erroConexaoSheet"
        tipo="erro_conexao"
      />

      <v-dialog v-model="visualizarColetaDialog" @click:outside="$_clearHashRoute()" max-width="700px">
        <v-card class="rounded-xl">
          
          <v-card-title class="headline d-flex justify-space-between align-center px-6 pt-5 pb-3">
            <div class="d-flex align-center">
              <v-icon color="#4c6faf" class="mr-3">mdi-text-box-search-outline</v-icon>
              <span class="font-weight-bold" style="color: #4c6faf; font-size: 1.25rem;">Detalhes da Coleta</span>
            </div>
            <v-btn icon color="grey darken-1" @click="visualizarColetaDialog = false; $_clearHashRoute();">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="px-6 pt-2 pb-4">
            <div v-if="ordemSelecionadaVisualizacao">
              
              <div class="rounded-lg grey lighten-4 pa-4 mb-6">
                <div 
                  v-for="(detalhe, index) in coletaDetalhes" 
                  :key="detalhe.label" 
                  class="d-flex justify-space-between mb-2"
                  :class="{'mb-0': index === coletaDetalhes.length - 1}"
                >
                  <span class="text-body-2 grey--text text--darken-2 font-weight-medium">{{ detalhe.label }}:</span>
                  <span class="text-body-2 font-weight-bold black--text text-right" style="white-space: pre-line;">
                    {{ detalhe.value }}
                  </span>
                </div>
              </div>
              
              <div class="d-flex align-center mb-3">
                <v-icon small color="grey darken-1" class="mr-2">mdi-format-list-bulleted</v-icon>
                <span class="font-weight-bold text-subtitle-1 grey--text text--darken-3">Itens da Coleta</span>
              </div>

              <v-card outlined class="rounded-lg">
                <simplebar data-simplebar :autoHide="false">
                  <v-simple-table style="min-width: 600px;">
                    <template v-slot:default>
                      <thead>
                        <tr class="primary" color="">
                          <th class="text-left font-weight-bold white--text text--darken-3">Cód. Int.</th>
                          <th class="text-left font-weight-bold white--text text--darken-3">Produto (Descrição)</th>
                          <th class="text-center font-weight-bold white--text text--darken-3">Qtd</th>
                          <th class="text-left font-weight-bold white--text text--darken-3">Observação</th>
                          <th class="text-center font-weight-bold white--text text--darken-3">Imagens</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in itensDaColeta" :key="item.id">
                          <td class="text-right font-weight-medium text-body-2">{{ item.produto.procodigointerno }}</td>
                          <td class="text-body-2">{{ item.produto.prodescricao }}</td>
                          <td class="text-center">
                            <v-chip small color="blue lighten-5" text-color="blue darken-2" class="font-weight-bold">
                              {{ item.osiquantidade }}
                            </v-chip>
                          </td>
                          <td :style="{whiteSpace: 'pre-line'}" class="text-caption grey--text text--darken-2">
                            {{ item.osiobservacao ? item.osiobservacao : '-'}}
                          </td>
                          <td class="text-center">
                            <v-badge
                              :content="item.imageCount"
                              :value="item.imageCount > 0"
                              color="blue darken-1"
                              overlap
                              bordered
                            >
                              <v-btn
                                icon
                                small
                                :color="item.imageCount > 0 ? 'blue darken-2' : 'grey lighten-1'"
                                @click="item.imageCount > 0 ? $_visualizarImagens(item) : null"
                                :style="{ cursor: item.imageCount > 0 ? 'pointer' : 'default' }"
                              >
                                <v-icon>mdi-camera-outline</v-icon>
                              </v-btn>
                            </v-badge>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </simplebar>
              </v-card>
            </div>
          </v-card-text>
          
          <v-card-actions class="px-6 pb-6 pt-0 justify-end">
            <v-btn 
              color="grey darken-1" 
              text 
              class="text-capitalize font-weight-medium px-4" 
              @click="$_clearHashRoute(), visualizarColetaDialog = false"
            >
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

       <v-bottom-sheet v-model="visualizarImagensSheet" @click:outside="$_clearHashRoute('#coleta')" content-class="rounded-t-lg">
        <v-card>
          <v-toolbar color="primary" dark dense flat>
            <v-toolbar-title class="font-weight-medium text-body-1">
              Arquivos: {{ itemSelecionadoImagens ? itemSelecionadoImagens.produto.prodescricao : '' }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="$_fecharVisualizadorImagens">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pa-4">
            <div v-if="itemSelecionadoImagens">
              <p v-if="!itemSelecionadoImagens.imageCount" class="text-center my-4">Nenhuma imagem encontrada para este item.</p>
               <div v-else style="max-height: 250px; overflow-y: auto; overflow-x: hidden;">
              <v-row dense>
                <v-col v-for="(i, index) in itemSelecionadoImagens.imagens" :key="i.id" class="d-flex child-flex" cols="4" sm="3" md="2">
                  <v-card @click="$_abrirMidiaModal(index)" flat hover class="d-flex align-center justify-center rounded-lg">
                    <v-img v-if="i.tipo !== 'video'" :src="i.dados" aspect-ratio="1" class="grey lighten-2">
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                      <div v-else style="position: relative; height: 100%; width: 100%;">
                        <video class="imagem-preview" style="width: 100%; height: 100%; object-fit: cover;">
                          <source :src="i.dados" type="video/mp4" />
                        </video>
                        <div
                          class="d-flex align-center justify-center"
                          style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.3);"
                        >
                          <v-icon color="white" size="48">
                            mdi-play-circle-outline
                          </v-icon>
                        </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            </div>
          </v-card-text>
        </v-card>
      </v-bottom-sheet>

      <v-dialog v-model="midiaModalAberto" fullscreen hide-overlay transition="slide-y-reverse-transition">
      <v-card style="height: 100%; background-color: #000;">
        <v-card-text class="d-flex flex-column justify-center align-center" style="height: 100%; position: relative;">
          
          <!-- Botão de fechar -->
          <v-btn 
            icon 
            large 
            color="white"
            style="position: absolute; top: 16px; right: 16px; z-index: 10;"
            @click="$_fecharMidiaModal"
          >
            <v-icon large>mdi-close</v-icon>
          </v-btn>

          <!-- Exibição de imagem -->
          <img 
            v-if="midiaModal && midiaModal.tipo === 'image'"
            :src="midiaModal.dados" 
            class="midia-fullscreen"
            style="max-width: 90%; max-height: 90%; object-fit: contain;"
          >

          <!-- Exibição de vídeo (pausado por padrão) -->
          <video 
            v-else-if="midiaModal && midiaModal.tipo === 'video'"
            ref="videoFullscreen"
            controls
            class="midia-fullscreen"
            style="max-width: 90%; max-height: 90%; object-fit: contain;"
          >
            <source :src="midiaModal.dados" type="video/mp4">
          </video>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import db from '@/plugins/dexie';
import { COLETA_STORAGE, USER_STORAGE } from '@/constants/STORAGE';
import { mapActions, mapMutations, mapState } from 'vuex';
import moment from 'moment-timezone';
import { ROUTE_COLETA_CADASTRO } from '@/constants/ROUTES';
// import { SetupEnvioLocal } from '@/utils/atualizalocal';
import BottomSheetHandler from '@/components/coleta/BottomSheetHandler.vue';
import geraData from '@/utils/geradata';
import geraDataV2 from '@/utils/geraDataV2';

import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';

import $_enviaColeta from '@/utils/local/enviaColeta';

import deepEquals from '@/utils/deep-equals';
import {
  getNumberQueryValue, getQueryValue, getSortQueryValue, setQueryValue, setSortQueryValue,
} from '@/services/query-string';

import { COLETA_QUERIES, GENERIC_QUERIES } from '@/constants/QUERY_FILTERS';

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}

export default {
  name: 'ViewColeta',

  components: {
    simplebar,
    BottomSheetHandler
  },

  data() {
    const hoje = new Date();
    const dataPassada = new Date();
    dataPassada.setDate(hoje.getDate() - 30);

    const currentDate = hoje.toJSON().replace(/T.*$/, '');
    const pastDate = dataPassada.toJSON().replace(/T.*$/, '');

    return {
      filtroAplicado: false,
      loading: false,
      usuario: Number(getSessionStorage(USER_STORAGE.useidusuario, null)),
      ordemservico: [],
      ordemservicoitem: [],
      cliente: [],
      itenscoleta: [],
      
      data: [],
      
      ordemservicoMap: null,
      ordemservicoitemMap: null,
      clienteMap: null,
      produto: [],
      produtoMap: null,

      encerrarSheet: false,
      ordemSelecionada: {},
      visualizarColetaDialog: false,
      ordemSelecionadaVisualizacao: null,
      itensDaColeta: [],
      itemSelecionadoImagens: null,
      visualizarImagensSheet: false,

      midiaModalAberto: null,
      midiaModal: null,
      indiceMidiaModal: null,

      deletarSheet: false,
      coletaSelecionadaDeletar: null,
      erroConexaoSheet: false,

       filters: {
        search: getSessionStorage(COLETA_STORAGE.search, null),
        createdFrom: getSessionStorage(COLETA_STORAGE.createFrom, pastDate), 
        createdBefore: getSessionStorage(COLETA_STORAGE.createBefore, currentDate),
        parametro: getSessionStorage(COLETA_STORAGE.parametro),
        status: getQueryValue('status', 'Abertas'),
      },

      options: {
        itemsPerPage: 9999,
        sortBy: ['orsdatacadastro'],
        sortDesc: [true],
      },

      dialognroexterno: false,
    };
  },

  computed: {
    ...mapState({
      $_cacheOrdemServico: (state) => state.cache.cache_ordemservico,
      $_cacheOrdemServicoItem: (state) => state.cache.cache_ordemservicoitem,
      $_cacheCliente: (state) => state.cache.cache_cliente,
      $_cacheProduto: (state) => state.cache.cache_produto,
      $_produtoMap: (state) => state.cache.cache_produtoMap,
      $$_filtroStatus: (state) => state.coleta.filtroStatus,
    }),

    coletaDetalhes() {
      if (!this.ordemSelecionadaVisualizacao) return [];
      const o = this.ordemSelecionadaVisualizacao;
      const detalhes = [
        { label: 'Cliente', value: o.orscliente },
        { label: 'Data Cadastro', value: this.$_FormataDataGeral(o.orsdatacadastro) },
        { label: 'Nº Pedido', value: o.orsidnuvem || o.id },
        { label: 'Quantidade de itens', value: o.orsquantidade },
        { label: 'Valor Total', value: this.formatarValor(o.orsvalortotal) },
      ];
      if (o.orsobservacao) {
        detalhes.push({ label: 'Observação', value: o.orsobservacao });
      }
      if (o.orsdatafechamento) {
        detalhes.push({ label: 'Encerrado em', value: this.$_FormataDataGeral(o.orsdatafechamento, true) });
      }
      return detalhes;
    }
  },
        
  methods: {
    ...mapMutations({
      $_adicionarCache: 'cache/SET_CACHE',
    }),
  
    ...mapActions({
      $_getCache: 'cache/getCache',
      $_reloadCache: 'cache/reloadCache',
    }),

    ...mapMutations({
      $_setColeta: 'coleta/SET_COLETA',
      $_setColetaItens: 'coleta/SET_COLETAITENS',
    }),

    formatarValor(valor) {
      if (typeof valor !== 'number') {
        const parsed = parseFloat(valor);
        if (!isNaN(parsed)) valor = parsed;
        return valor;
      }
      return valor.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },

    $_FormataDataGeral(date, hora = false) {
      if (hora) return moment.utc(date).format('DD/MM/YYYY HH:mm');
      return moment.utc(date).format('DD/MM/YYYY');
    },
    
    getOrderKey(ordem) {
      return ordem.orsidnuvem ?? `local-${ordem.orsidlocal}`;
    },

    getItemKey(item) {
      return item.osiidordemserviconuvem ?? `local-${item.osiidordemservicolocal}`;
    },

    async $_setupCache() {
    const orscache = await this.$_getCache('ordemservico');
    const osicache = await this.$_getCache('ordemservicoitem');
    const clicache = await this.$_getCache('cliente');
    const grucache = await this.$_getCache('grupo');
    const procache = await this.$_getCache('produto');

    if (!orscache) {
      this.ordemservico = await db.ordemservico
        .orderBy('orsdatacadastro')
        .reverse()
        .toArray();
      this.$_adicionarCache({ tabela: 'ordemservico', dados: this.ordemservico });
    } else {
      this.ordemservico = this.$_cacheOrdemServico;
    }

    if (!osicache) {
      this.ordemservicoitem = await db.ordemservicoitem.toArray();
      this.$_adicionarCache({ tabela: 'ordemservicoitem', dados: this.ordemservicoitem });
    } else {
      this.ordemservicoitem = this.$_cacheOrdemServicoItem;
    }

    if (!clicache) {
      this.cliente = await db.cliente.toArray();
      this.$_adicionarCache({ tabela: 'cliente', dados: this.cliente });
    } else {
      this.cliente = this.$_cacheCliente;
    }

    if (!grucache) this.$_adicionarCache({ tabela: 'grupo', dados: await db.grupo.toArray()});
    
    
    if (!procache) this.$_adicionarCache({ tabela: 'produto', dados: await db.produto.toArray()})

    this.ordemservicoitemMap = new Map();
    for (const item of this.ordemservicoitem) {
      const key = this.getItemKey(item);
      if (!this.ordemservicoitemMap.has(key)) {
        this.ordemservicoitemMap.set(key, []);
      }
      this.ordemservicoitemMap.get(key).push(item);
    }

    this.clienteMap = new Map(this.cliente.map(c => [c.cliidcliente, c]));

  },

  formatarData(data, fimdodia = false) {
    if (!data) return null;

    const [ano, mes, dia] = data.split('-').map(Number);

    if (fimdodia)
      return new Date(ano, mes - 1, dia, 23, 59, 59, 999);

    return new Date(ano, mes - 1, dia, 0, 0, 0, 0);
  },

  async $_load() {

    await this.$_setupCache();
        
    sessionStorage.setItem(COLETA_STORAGE.page, this.options.page);
    sessionStorage.setItem(COLETA_STORAGE.search, this.filters.search);
    sessionStorage.setItem(COLETA_STORAGE.createFrom, this.filters.createdFrom);
    sessionStorage.setItem(COLETA_STORAGE.createBefore, this.filters.createdBefore);
    sessionStorage.setItem(COLETA_STORAGE.parametro, this.filters.parametro);

    const dateFrom = geraData(this.formatarData(this.filters.createdFrom, false));
    const dateBefore = geraData(this.formatarData(this.filters.createdBefore, true));
    // console.log(geraData(dateFrom), geraData(dateBefore))

    const clienteId = this.filters.parametro ? Number(this.filters.parametro) : null;

    const ordensFiltradas = this.ordemservico.filter(ors => {
      const dataOs = geraData(ors.orsdatacadastro);


      if (ors.orsdatafechamento && this.$$_filtroStatus === 'Abertas') return false;

      if (!ors.orsdatafechamento && this.$$_filtroStatus === 'Encerradas') return false;

      if (dateFrom && dataOs < dateFrom) return false;

      if (dateBefore && dataOs > dateBefore) return false;

      if (clienteId && ors.orsidcliente !== clienteId) return false;

      return true;
    });

    this.ordemservicoMap = new Map(
      ordensFiltradas.map(ors => [this.getOrderKey(ors), ors])
    );

    this.data = await Promise.all(ordensFiltradas.map(async ors => {
      const ordemKey = this.getOrderKey(ors);

      const itens = (this.ordemservicoitemMap.get(ordemKey) || [])
        .filter((i) => !i.osiexclusao);

      let quantidade = 0;
      let valortotal = 0;

      const itensFormatados = await Promise.all(itens.map(async item => {
        const produto = this.$_produtoMap.get(`${item.osicodigoproduto}`);
        
        const imagensCount = await db.imagem.where({ relacao: 'ordemservicoitem', relacaoidlocal: item.id }).count();

        return {
          idcortamanhofinal: item.osiidproduto || 'S/C',
          descricao: produto ? produto.prodescricao : (item.osiobservacao || 'Produto sem descrição'),
          quantidade: parseFloat(item.osiquantidade) || 1,
          valorliquido: parseFloat(item.osivalorunitario) || 0,
          imageCount: imagensCount
        };
      }));

      for (const item of itens) {
        quantidade += item.osiquantidade;
        valortotal += (Number(item.osiquantidade) * Number(item.osivalorunitario || 0));
      }

      const cliente = this.clienteMap.get(Number(ors.orsidcliente));

      return {
        ...ors,
        orsdatacadastro: geraDataV2({ date: ors.orsdatacadastro }),
        orscliente: cliente?.clinome ?? 'N/D',
        orsquantidade: quantidade,
        orsvalortotal: valortotal,
        orsdatafechamento: ors.orsdatafechamento ?? null,
        orsdefeito: ors.orsdefeito ?? '',
        orsobservacaoextra: ors.orsobservacaoextra ?? '',
        showItems: false,
        itens: itensFormatados,
      };
    }));

    this.data.sort((a, b) => new Date(b.orsdatacadastro) - new Date(a.orsdatacadastro));
  },

    
    $_adicionarColeta() {
      this.$router.push({
        ...ROUTE_COLETA_CADASTRO,
      })
    },
    
    $_abrirColeta(coleta) {
      const ordemKey = this.getOrderKey(coleta)
      // console.log('itens da coleta', this.ordemservicoitemMap.get(ordemKey))
      this.$_setColeta({
        ...coleta,
      });

      const itens = this.ordemservicoitemMap.get(ordemKey);
      this.$_setColetaItens(itens.filter((i) => !i.osiexclusao));
      
      this.$router.push({
        ...ROUTE_COLETA_CADASTRO,
      });
    },

    $_encerrarColeta(coleta) {
      // console.log('clicado no encerrar', coleta);
      this.ordemSelecionada = coleta;
      this.encerrarSheet = true;
    },

    async $_confirmEncerrar() {
      this.encerrarSheet = false;
      const idOrdem = this.ordemSelecionada ? this.ordemSelecionada.id : null;
      if (!idOrdem) return;

      try {
        await db.ordemservico.update(idOrdem, {
          orsdatafechamento: geraData(),
          orsdatanuvem: null,
        });

        if (navigator.onLine) {
          await $_enviaColeta();
        }

        const osAtualizada = await db.ordemservico.get(idOrdem);

        if (!osAtualizada?.orsdatanuvem) {
          this.erroConexaoSheet = true;
        }

        await this.$_reloadCache('ordemservico');
        await this.$_load();
      } catch (err) {
        console.error("Erro ao encerrar coleta:", err);
      }
    },

    $_deletarColeta(coleta) {
      this.coletaSelecionadaDeletar = coleta;
      this.deletarSheet = true;
    },

    async $_confirmDeletarColeta() {
      this.deletarSheet = false;
      this.$nextTick(async () => {
        const coletaId = this.coletaSelecionadaDeletar.id;
        
        const ordemKey = this.getOrderKey(this.coletaSelecionadaDeletar);
        const itens = this.ordemservicoitemMap.get(ordemKey) || [];
        
        for (const item of itens) {
          const imagens = await db.imagem.where({ 
            relacao: 'ordemservicoitem', 
            relacaoidlocal: item.id 
          }).toArray();
          
          for (const imagem of imagens) {
            await db.imagem.delete(imagem.id);
          }
          
          await db.ordemservicoitem.delete(item.id);
        }
        
        await db.ordemservico.delete(coletaId);
        
        await this.$_reloadCache('ordemservico');
        await this.$_reloadCache('ordemservicoitem');
        await this.$_load();
        $_enviaColeta();
        
        this.coletaSelecionadaDeletar = null;
      });
    },

    async $_abrirOuVisualizarColeta(ordem) {
      if (ordem.orsdatafechamento) {
        this.ordemSelecionadaVisualizacao = ordem;
        const ordemKey = this.getOrderKey(ordem);
        const itens = this.ordemservicoitemMap.get(ordemKey);
        
        const itensComProdutosEImagens = await Promise.all(
            (itens || [])
            .filter((i) => !i.osiexclusao)
            .map(async item => {
                const produto = this.$_produtoMap.get(`${item.osicodigoproduto}`);
                const imagens = await db.imagem.where({ relacao: 'ordemservicoitem', relacaoidlocal: item.id }).toArray();
                return {
                    ...item,
                    produto: produto || { prodescricao: 'Produto não encontrado', procodigointerno: 'N/A' },
                    imageCount: imagens.length,
                    imagens: imagens.map((i) => {
                      return {
                        ...i,
                        dados: URL.createObjectURL(i.blob),
                        tipo: i.blob.type.split('/')[0],
                      }
                    })
                }
            })
        );

        this.itensDaColeta = itensComProdutosEImagens;
        this.visualizarColetaDialog = true;
        window.location.hash = '#coleta';
      } else {
        this.$_abrirColeta(ordem);
      }
    },

    $_visualizarImagens(item) {
      this.itemSelecionadoImagens = item;
      this.visualizarImagensSheet = true;
      window.location.hash = '#imagens';
    },

    $_fecharVisualizadorImagens() {
      this.visualizarImagensSheet = false;
      this.itemSelecionadoImagens = null;
      window.location.hash = '#coleta';
    },

    $_abrirMidiaModal(index) {
      this.indiceMidiaModal = index;
      this.midiaModal = this.itemSelecionadoImagens.imagens[index];
      this.midiaModalAberto = true;
      window.location.hash = '#midia';


      this.$nextTick(() => {
        if (this.$refs.videoFullscreen && this.midiaModal && this.midiaModal.tipo === 'video') {
          this.$refs.videoFullscreen.pause();
        }
      });
    },

    $_fecharMidiaModal() {
      if (this.$refs.videoFullscreen && this.midiaModal.tipo === 'video') {
        this.$refs.videoFullscreen.pause();
        this.$refs.videoFullscreen.currentTime = 0;
      }
      this.midiaModalAberto = false;
      this.midiaModal = null;
      this.indiceMidiaModal = null;
      window.location.hash = '#imagens'
    },
    
    async $_clearHashRoute(hash) {
      this.$router.replace({
        path: this.$route.path,
        query: this.$route.query,
        hash: '',
      }).catch(() => {});
      if (hash) window.location.hash = hash
    },

  },

  created() {

    this.$nextTick(() => {
      const idTimerAntigo = sessionStorage.getItem('timerid');
      if (idTimerAntigo) {
        clearInterval(idTimerAntigo);
      }
      sessionStorage.removeItem('timerid');
      this.$_load();
      this.$_clearHashRoute();
    });
  },

  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler() {
        if (this.$route?.hash) {
          if (this.$route?.hash === '#coleta') {
           this.visualizarImagensSheet = false;
           this.visualizarColetaDialog = true;
          }
          if (this.$route?.hash === '#imagens') {
            this.midiaModalAberto = false;
            this.visualizarImagensSheet = true;
          } 
          if (this.$route?.hash === '#midia')  this.midiaModalAberto = true;
        } else {
          this.visualizarColetaDialog = false;
          this.visualizarImagensSheet = false;
          this.midiaModalAberto = false;
        }

        this.options.page = getNumberQueryValue(GENERIC_QUERIES.page, this.options.page);

        const defaultSort = `${this.options.sortDesc[0] ? '+' : '-'}${this.options.sortBy[0]}`;
        const { field, order } = getSortQueryValue(GENERIC_QUERIES.sort, defaultSort);
        this.options.sortBy[0] = field;
        this.options.sortDesc[0] = order;

        const filters = {
          search: getQueryValue(GENERIC_QUERIES.search, null),
          createdFrom: getQueryValue(COLETA_QUERIES.createdFrom, this.filters.createdFrom),
          createdBefore: getQueryValue(
            COLETA_QUERIES.createdBefore,
            this.filters.createdBefore,
          ),
          parametro: getQueryValue(
            COLETA_QUERIES.codigocliente,
            this.filters.parametro,
          ),
          status: getQueryValue('status', this.filters.status),
        };

        if (!deepEquals(this.filters, filters)) {
          this.filters.search = filters.search;
          this.filters.createdFrom = filters.createdFrom;
          this.filters.createdBefore = filters.createdBefore;
          this.filters.parametro = filters.parametro;
          this.filters.status = filters.status;
          this.$_load();
        }
      },
    },
    options: {
      deep: true,
      immediate: true,
      handler() {
        setSortQueryValue(GENERIC_QUERIES.sort, this.options.sortBy[0], this.options.sortDesc[0]);
        setQueryValue(COLETA_QUERIES.createdFrom, this.filters.createdFrom);
        setQueryValue(COLETA_QUERIES.createdBefore, this.filters.createdBefore);
        setQueryValue(COLETA_QUERIES.codigocliente, this.filters.parametro);
        setQueryValue('status', this.$$_filtroStatus);
      },
    },
  },
};
</script>

<style scoped>
.container-pedido{
  padding: 0;
  margin: 0;
}

.header-fixo {
  justify-content: center;
  position: fixed;
  width: 100%;
  margin: -12px 0 0 0;
  z-index: 3;
  background-color: #eeeeee; 
  padding: 12px 0 12px 0;
}

.lista-com-padding {
  padding-top: 50px;
}

.card {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.card__consumidor {
  padding: 12px 16px;
  font-size: 1.1rem;
  color: white;
  background-color: #4c6faf;
  transition: background-color 0.3s ease;
}

.card__consumidor--encerrada {
  background-color: #4caf50 !important; 
}

.card__detalhe {
  display: flex;
  align-items: center;
  padding: 0 16px 0 16px;
  flex-grow: 1;
}

.card__detalhe__icone-wrapper {
  margin-right: 16px;
}

.card__detalhe-conteudo {
  flex-grow: 1;
  font-size: 0.9rem;
}

.card__detalhe-conteudo > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.table-scroll-container {
  max-height: 165px; 
  padding-right: 10px;
}
.table-scroll-container ::v-deep .simplebar-scrollbar::before {
  background: rgba(76, 111, 175, 0.4) !important;
}

@media (min-width: 960px) {
  .header-fixo {
  justify-content: center;
  position: fixed;
  width: 80%;
  margin: 0;
  z-index: 3;
  background-color: #eeeeee; 

}
.lista-com-padding {
  justify-content: center;
  margin: auto;
  width: 80%;
  margin-top: 20px;
  padding-top: 50px;

}
.buton-add{
  padding-right: 16px;

}
}
</style>